// eslint-disable-next-line @typescript-eslint/no-empty-function
export const EMPTY_CALLBACK = () => {};

export const INPUT_NAME_MAX_LENGTH = 72;
export const INPUT_PERSON_NAME_MAX_LENGTH = 72;

export const createElipsis = (text: string, maxLength: number) => {
	if (text.length > maxLength) {
		return `${text.substring(0, maxLength - 3)}...`;
	}
	return text;
};
